class FaqTabs extends HTMLElement {
  #tabs = [];

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.#tabs = Array.from(this.querySelectorAll('[data-faq-tab]'));
    this.#tabs.forEach((tab) => {
      const button = tab.querySelector('[data-faq-toggle]');
      button?.addEventListener('click', this.#onToggle);

      const content = tab.querySelector('[data-faq-content]');
      if (content?.getAttribute('aria-hidden') === 'false') {
        content.style.maxHeight = `${content.scrollHeight}px`;
      }
    });
  }

  disconnectedCallback() {
    this.#tabs.forEach((tab) => {
      const button = tab.querySelector('[data-faq-toggle]');
      button?.removeEventListener('click', this.#onToggle);
    });
  }

  #onToggle = (event) => {
    const button = event.currentTarget;
    const tab = button.closest('[data-faq-tab]');
    const content = tab.querySelector('[data-faq-content]');
    const isOpen = button.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      this.#close(button, content);
      return;
    }

    this.#tabs.forEach((otherTab) => {
      if (otherTab === tab) return;
      const otherButton = otherTab.querySelector('[data-faq-toggle]');
      const otherContent = otherTab.querySelector('[data-faq-content]');
      if (otherButton?.getAttribute('aria-expanded') === 'true') {
        this.#close(otherButton, otherContent);
      }
    });

    this.#open(button, content);
  };

  #open(button, content) {
    button.setAttribute('aria-expanded', 'true');
    if (!content) return;
    content.setAttribute('aria-hidden', 'false');
    content.removeAttribute('inert');
    content.style.maxHeight = `${content.scrollHeight}px`;
  }

  #close(button, content) {
    button.setAttribute('aria-expanded', 'false');
    if (!content) return;
    content.setAttribute('aria-hidden', 'true');
    content.setAttribute('inert', '');
    content.style.maxHeight = '0px';
  }
}

if (!customElements.get('faq-tabs')) {
  customElements.define('faq-tabs', FaqTabs);
}
